import { useContext, useMemo } from 'react';
import { UserContext } from 'src/store/ContextStore';

/**
 * The signed-in clinician's display name ("First Last"), for stamping on
 * records they create — `recordedBy` and friends.
 *
 * Deliberately NOT `pedigreeSelectedUsers.selectedUser`: that is the proband
 * whose chart is open, so defaulting a clinical record from it attributed
 * every record to the patient. On charts seeded from a family history
 * questionnaire that made new clinician-entered records look as though they
 * had come from the questionnaire submission.
 *
 * Returns '' when the context has no name, so callers can fall back to an
 * empty (clinician-fillable) field rather than a wrong attribution.
 */
export const useLoggedInUserName = () => {
  const { user } = useContext(UserContext) || {};
  const firstName = user?.firstName;
  const lastName = user?.lastName;

  return useMemo(
    () => [firstName, lastName].filter(Boolean).join(' ').trim(),
    [firstName, lastName]
  );
};

export default useLoggedInUserName;
